import React from 'react';
import ExpandableSection from '../ui/ExpandableSection';
import CartItem from './CartItem';
import CartSummary from './CartSummary';

const ShoppingCartIcon = ({ size = 20, className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
    viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);

const CartSection = ({
  lessons, isExpanded, onToggleExpand,
  onToggleSelection, onRemoveLesson,
  selectedCount, subtotal,
}) => (
  <ExpandableSection
    title={`סל השיעורים שלי (${lessons.length})`}
    icon={<ShoppingCartIcon size={18} />}
    isExpanded={isExpanded}
    onToggle={onToggleExpand}
    headerClassName="bg-gradient-to-l from-indigo-50 to-blue-50"
  >
    <div className="p-3 sm:p-4">
      {lessons.length > 0 ? (
        <div className="space-y-2 sm:space-y-3">
          {lessons.map((lesson) => (
            <CartItem
              key={lesson.id}
              lesson={lesson}
              onToggleSelection={onToggleSelection}
              onRemove={onRemoveLesson}
            />
          ))}
          <CartSummary selectedCount={selectedCount} subtotal={subtotal} />
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-10 text-center">
          <ShoppingCartIcon size={40} className="text-gray-300 mb-3" />
          <p className="text-sm text-gray-500">סל השיעורים שלך ריק</p>
        </div>
      )}
    </div>
  </ExpandableSection>
);

export default CartSection;